import axios from "axios";

let apiInstance = axios.create({
    baseURL: process.env.LOGSTASH_BASE_URL
});

apiInstance.interceptors.request.use((config) => {
    if (process.env.LOGSTASH_AUTHORISATION) {
        config.headers.Authorization = `Basic ${process.env.LOGSTASH_AUTHORISATION}`;
    }

    return config;
}, (err) => Promise.reject(err));

export const logstashAPI = apiInstance;
